import { ReactNode } from 'react';

type RipplingStepsProps = {
  children: ReactNode;
};

export const RipplingSteps = ({ children }: RipplingStepsProps) => {
  return <ol className="space-y-7 [counter-reset:step]">{children}</ol>;
};
